
<!-- 登陆页面-->
<template>
  <div class="container">
    <div @click="back">
      <img src="../assets/back4.png" class="turn" style="  position: fixed;left: 0px;top: 0px;width: 80px;height:80px;z-index:9999; " id="musicStopIco">
    </div>

    <div class="successTip" :style="{'display':tips}" >
      <div style="margin-top: 20px;font-family: myMind;font-size: 20px;">
        {{successTip}}
      </div>
    </div>
        <div class="tips" :style="{'visibility':tips}">
          <div class="text">请检查网络是否连接</div>
          <div class="buttonArea"><button class="button2" onclick="cancel()">确认</button></div>
        </div>
    <div class="logoImg">
      <img src="../assets/logo_y.gif" width="200px" >
    </div>
    <form v-model="loginForm" class="loginform">



      <div :style="{'visibility':mobileTip}" >
        <div class="usernameTip">
          请输入手机号
        </div>
        <div class="commonTip"></div>
      </div>

      <div style="display: flex;flex-wrap: wrap;width: 80%;">
        <input class="input " style="margin-left: -10px;width: 100%;" type="text" name="username" v-model="loginForm.username"  placeholder="手机号" @blur="changeVal" @focus="usernameStateChange"><br>
      </div>


      <div :style="{'visibility':smsCodeTip}">
        <div class="smsCodeTip" >
          请输入验证码
        </div>
        <div class="commonTip"></div>
      </div>

      <div style="display: flex;flex-wrap: wrap;width: 100%;">
        <div style="width: 30%;">
          <input class="input " style="margin-left: -10px; width: 100%;" type="text" name="password" v-model="loginForm.smsCode" placeholder="验证码" @blur="changeVal" @focus="smsCodeStateChange">
        </div>
        <div style="width: 45%;margin-left: 10px;"><input class="button" style="margin-left:30px;background-color: #b2ebf2" :style="{'opacity':opacity}" type="button"  v-model="loginForm.msg" v-bind:disabled="btnDisable" @click="getMsgCode"></div>
      </div>

      <div :style="{'visibility':passwordTip}">
        <div class="passwordTip">
          请输入密码
        </div>
        <div class="commonTip"></div>
      </div>

      <div style="display: flex;flex-wrap: wrap;width: 80%;">
        <input class="input " style="margin-left: -10px;width: 100%;" type="password" name="username" v-model="loginForm.password"  placeholder="设置密码" @blur="changeVal" @focus="passwordStateChange"><br>
      </div>

      <div style="text-align: center;color: red;font-size: 15px;font-family: myMind" class="tip">{{tip}}</div>

      <div>
        <input class="button" style="margin-left: -10px;"  type="button" value="重置密码" @blur="changeVal" @click="changePwd">
      </div>

    </form>




  </div>
</template>

<script>
  import axios from 'axios';
  import jwt from 'jsonwebtoken';

  export default {
    name: "Register",
    data:function(){
      return{
        loginForm:{
          username:'',
          password:'',
          smsCode:'',
          msg:'获取验证码'
        },
        tip:' ',
        time:60,
        btnDisable:false,
        btnColor:false,
        opacity:1,
        mobileTip:'hidden',
        passwordTip:'hidden',
        smsCodeTip:'hidden',
        tips:'none',
        successTip:'',
      }
    },
    mounted() {
      document.body.style.height=window.document.documentElement.clientHeight;
    },
    methods:{
      login(){
        axios.post(this.GLOBAL.serverURL+'api/changepassword/',{
          username:this.loginForm.username,
          password:this.loginForm.password,
          smscode:this.loginForm.smsCode
        })
          .then(res=>{
            if(res.data.ret=='1000'){
              this.GLOBAL.token =res.data.token;  //将token存入全局变量中

              this.GLOBAL.userId =jwt.decode(res.data.token).id;

              //在IE 浏览器使用window.localStorage会报错
              window.localStorage.setItem('token',res.data.token);   //将token存入浏览器localStorage
              window.localStorage.setItem('username',jwt.decode(res.data.token).username); //将解码后的用户信息存入浏览器localStorage
              window.localStorage.setItem('id',jwt.decode(res.data.token).id); //将解码后的用户信息存入浏览器localStorage

              this.$router.push("/home");  //进入课程页
            }else{
              this.tip='用户名或密码错误!';

            }
          })
          .catch(err=>{
            console.log('%c catch...','color:red;font-size:15px;');
            console.log(err);
          })
          .finally(res=>{

          });
      },

      changeVal(){
        this.tip='';
      },

      changePwd(){
        if(this.checkAllInput()){
          axios.post(this.GLOBAL.serverURL+'api/changepassword/',{
            username:this.loginForm.username,
            password:this.loginForm.password,
            smscode:this.loginForm.smsCode
          }).then(res =>{
            console.log('%c 注册返回','font-size:20px');
            console.log(res);
            this.tip=res.data.message;

            if(res.data.code==200){
              this.successTip='密码修改成功！3秒钟后即将跳转到登陆页面！'
              this.tips='inline';
              setTimeout(this.back,2000);
            }



         //   setTimeout(this.back,2000);

          }).finally(e =>{

          })
        }
      },


      getMsgCode(){
        if(this.checkMoble()){
          axios.post(this.GLOBAL.serverURL+'api/code/',{mobile:this.loginForm.username}
          ).then(res =>{
            console.log('%c 注册返回','font-size:20px');
            console.log(res);
            if(res.data.code==400){
              this.successTip='频繁操作！'
              this.tips='inline';
               setTimeout(this.setTips,3000);
            }
          }).catch(err =>{

          }).finally(e =>{

          })
          console.log('%c 获取验证码','font-size:20px;');
          // this.loginForm.msg='11111';
          this.countDown();
        }

      },
      countDown(){
        if(this.time>0){
          setTimeout(this.countDown,1000);
          this.time=this.time-1;
          console.log(this.time);
          this.loginForm.msg=this.time;
          this.btnDisable=true;
          this.btnColor=true;
          this.opacity=0.5;
        }else{
          this.loginForm.msg='获取验证码';
          this.btnDisable=false;
          this.time=60;
          this.btnColor=false;
          this.opacity=1;
        }
      },

      back(){
        this.$router.back();
      },

      //检查手机号是否输入
      checkMoble(){
        if(this.loginForm.username!=''){
          return true;
        }else{

          this.mobileTip='visible';
          return false;
        }
      },
      //检查所有表单是否填写完整
      checkAllInput(){
        if(this.loginForm.username!=''&&this.loginForm.smsCode!=''&&this.loginForm.password!=''){
          return true;
        }else{
          if(this.loginForm.username==''){
            console.log('请输入用户名：');
            this.mobileTip='visible';
          }
          if(this.loginForm.password==''){
            console.log('请输入密码：');
            this.passwordTip='visible';
          }
          if(this.loginForm.smsCode==''){
            console.log('请输入验证码：');
            this.smsCodeTip='visible';
          }
          return false;

        }
      },

      /*
       * 获得焦点 提示框状态重置
       */
      usernameStateChange(){
        this.mobileTip='hidden';
      },

      passwordStateChange(){
        this.passwordTip='hidden';
      },
      smsCodeStateChange(){
        this.smsCodeTip='hidden';
      },

      setTips(){
        this.tips='none';
      }
    },
  }
</script>

<style scoped>

  @import "../assets/fonts/font.css";
  .container{
    background-image: url("../assets/bg3.jpg");
    background-repeat: no-repeat;
    /*background-attachment: fixed;*/
    background-size:  100%;
    width: 100%;
    height: 100%;
    display: flex;
  }

  .commonTip{
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 20px solid #ffe4c4;
    margin-left: 80px;
    margin-top: -10px;
  }
  .loginform{
    position: relative;
    left: 25%;
    top: 25%;
    width: 50%;
    height: 50%;
  }
  .logoImg{
    position: relative;
    left: 20%;
    top: 15%;
    height: 50%;
  }

  .btnColor{
    opacity: 0.5;
  }
  .userImg{
    position: fixed;
    left: 50%;
    top: 20%;
    z-index: 999;
  }
  .username{
    position: fixed;
    left: 50%;
    top: 20%;
  }

  .pwdImg{
    position: fixed;
    left: 50%;
    top: 35%;
    z-index: 999;
  }
  .password{
    position: fixed;
    left: 50%;
    top: 35%;
  }
  .loginBtn{
    position: fixed;
    left: 50%;
    top: 55%;
  }

  .tip{
    margin-top: 20px;
  }
  .input{

    outline: 0;
    border: 1px solid rgba(255, 255, 255, 0.8);
    background-color: rgba(255, 255, 255, 0.7);
    width: 250px;
    border-radius: 30px;
    padding: 10px 15px;
    margin: 0 auto 10px auto;
    display: block;
    text-align: center;
    font-size: 18px;
    color: black;
    -webkit-transition-duration: 0.25s;
    transition-duration: 0.25s;
    font-weight: 300;
    font-family: myMind;

  }
  .usernameTip{
    width: 60%;
    height: 20px;
    /*border: black solid 1px;*/
    border-radius: 4px;
    background-color: bisque;
    text-align: center;
    font-family: myMind;
    font-size: 10px;
    margin-left: 50px;
    line-height: 2;
  }

  .smsCodeTip{
    width: 60%;
    height: 20px;
    /*border: black solid 1px;*/
    border-radius: 4px;
    background-color: bisque;
    text-align: center;
    font-family: myMind;
    font-size: 10px;
    margin-left: 50px;
    line-height: 2;
  }
  .button{

    outline: 0;
    border: 1px solid rgba(85, 85, 87, 0.5);
    background-color: rgba(255, 255, 255, 0.3);
    width: 80%;
    border-radius: 30px;
    padding: 10px 15px;
    /*margin: 0 auto 10px auto;*/
    display: block;
    text-align: center;
    font-size: 18px;
    color: black;
    -webkit-transition-duration: 0.25s;
    transition-duration: 0.25s;
    font-weight: 800;
    margin-left: -10px;
    font-family: myMind;
  }

  .passwordTip{
    width: 60%;
    height: 20px;
    /*border: black solid 1px;*/
    border-radius: 4px;
    background-color: bisque;
    text-align: center;
    font-family: myMind;
    font-size: 10px;
    margin-left: 50px;
    line-height: 2;
  }


  .successTip{
    background-color: #b3eaf2;
    width: 43%;
    height: 30%;
    position: fixed;
    left: 30%;
    top: 10%;
    z-index: 8;
    border: black solid 3px;
    border-radius: 20px;
  }

  @media screen and (max-height: 400px){
    .logoImg{
      position: relative;
      left: 10%;
      top: 5%;
      height: 30%;
    }
    .loginform{
      position: relative;
      left: 15%;
      top: 21%;
      width: 60%;
      height: 50%;
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/ResetPwd.vue